__webpack_require__.p = "/Picklelo/";